<script setup lang="ts">
import { computed } from 'vue'
import { enUS } from 'date-fns/locale/en-US'
import { mdiBellCircle, mdiBellOutline, mdiCircleMedium } from '@mdi/js'
import { formatDistanceToNow } from 'date-fns/formatDistanceToNow'
import { useUserStore } from '../stores/user.store'

import SvgIcon from '@/shared/components/icon/SvgIcon.vue'
import BadgeMenu from '@/shared/components/badge/BadgeMenu.vue'

const userStore = useUserStore()

const isUnRead = computed(() => userStore.notifications.some((notifcation) => notifcation.isUnread))
</script>

<template>
  <BadgeMenu
    :badge="isUnRead"
    :title="$t('glossary.notification', 2)"
    :icon="mdiBellOutline"
    class="fill-white"
  >
    <div class="w-sm truncate bg-black">
      <div class="text-sm text-gray-300 border-b border-gray-800 p-2">
        {{ $t('glossary.notification', 2) }}
      </div>
      <div v-for="(notification, index) in userStore.notifications" :key="index">
        <div
          class="flex items-center cursor-default truncate py-1.5 hover:bg-gray-100 px-2"
          @mouseover="notification.isUnread = false"
        >
          <SvgIcon :path="notification.icon" class="fill-gray-300 h-10 w-10" />
          <div class="ms-1.5 w-full">
            <div class="flex justify-between items-center">
              <div>
                <div class="font-medium text-sm">{{ $t(notification.title) }}</div>
                <div class="font-light text-xs lowercase text-gray-600">
                  {{ formatDistanceToNow(new Date(), { locale: enUS }) }} {{ $t('common.ago') }}
                </div>
              </div>
              <div class="flex justify-between items-center">
                <SvgIcon
                  v-if="notification.isUnread"
                  :path="mdiCircleMedium"
                  class="fill-error h-5 w-5"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="userStore.notifications.length === 0" class="text-center py-2">
        <div class="flex justify-center items-center p-2">
          <SvgIcon :path="mdiBellCircle" class="fill-gray-300 h-16 w-16" />
        </div>
        <div class="font-light text-sm text-gray-300">{{ $t('message.noNotification', 2) }}</div>
      </div>
    </div>
  </BadgeMenu>
</template>
